var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('LoadingCell'):(_vm.error)?_c('BIconExclamationCircle',{staticClass:"text-danger"}):_vm._t("default",null,null,{ overview: _vm.overview })],2)}
var staticRenderFns = []

export { render, staticRenderFns }